export default String.raw`

input[type=date]::-webkit-inner-spin-button,
input[type=date]::-webkit-clear-button {
  -webkit-appearance: none;
  display: none;
}

.characters-counter {
  font-size: 10px;
  line-height: 10px;
  color: #959595;
}

.loading-cart-in-progress{
  margin-top: 30px;
  text-align: center;
}

.modal-opened{
  overflow: hidden;
}

.complaint-info{
  margin-bottom: 35px;
}

.zoom-js{
  cursor: pointer;
}

.open360 {
  position: absolute;
  z-index: 1;
  @media screen and (min-width: 1280px) {
    right: 0;
    top: 0;
  }
  @media screen and (max-width: 1279px) {
    right: 20px;
    top: 45px;
  }
}

.credit-limit-blocked {
  .delivery-and-payment-container {
    display: none;
    visibility: hidden;
  }
}

.pd05{
  padding: 0 5px;
}

.validation-vies-js, .validation-vies-allow-when-not-responding-js, .validation-vies-dont-allow-when-not-responding-js {
  color: $dangerColor !important;
}

textarea.validation-error-js {
  border: 1px solid $dangerColor !important;
}

input.validation-error-js {
  border: 1px solid $dangerColor !important;
}

select.validation-error-js {
  border: 1px solid $dangerColor !important;
}

.select.validation-error-js {
  border: 1px solid $dangerColor !important;
}

.error-container {
  display: flex;
  color: $dangerColor;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 24px;
  .svgIcon {
    position: relative;
    fill: $dangerColor;
    margin-right: 8px;
  }

  .text-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
  }

  p {
    max-width: 300px;
    margin: 0;
  }
}

.error {
  color: $dangerColor;
  fill: $dangerColor;
  display: flex;
  align-items: center;
  position: relative;
  gap: 8px;

  &__length {
    color: $dangerColor;
    fill: $dangerColor;
  }
}

.success {
  color: $successColor;
}

.quantity-error {
  color: $dangerColor;
  position: absolute;
  left: 10px;
  bottom: -10px;
  min-width: 100%;

  @media only screen and (min-width: 1279px) {
    position: relative;
    left: 0;
    bottom: 0;
  }
}

#file, #file-in-cart{
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.archival-product-info{
  position: absolute;
  top: -40px;
  right: 0;
  text-transform: uppercase;
  color: $primaryColor;
  font-style: italic;
}

.online-payment-error {
  background: #F2F6F9;
  text-align: center;
  padding: 100px;
}

.blocked-IE{
  position: fixed;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  text-align: center;
  line-height: 1.5;
  padding: 40px;
}

.blocked-IE-title{
  font-size: 30px;
}

.blocked-IE-container{
  display: inline-block;
  margin-top: 40px;
  padding: 20px;
  border: 1px solid $lightBorderColor;
}

.blocked-IE-info{
  font-size: 20px;
}

.blocked-IE-list{
  margin: 20px 0 0;
}

.blocked-IE-browser{
  display: inline-block;
  margin: 20px;
  a{
    color: $bgColor;
    &:hover{
      color: $bgColor;
    }
  }
}

.unit-ratio-info{
  font-size: 10px;
  color: $primaryColorFont;
}

.no-javascript {
  padding: 10px;
  background-color: #EF5350;
  color: #fff;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999999;

  &:hover {
    display: none;

    + .no-javascript {
      display: none;
    }
  }
}
.no-javascript-hidden {
  height: 44px;
  padding: 10px;
  background-color: transparent;
  color: transparent;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99999999;
}

/* ---- WAITING LAZY CIRCLE ---- */
.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: $waitingCircleWidth solid $waitingCircleTrack;
  border-right: $waitingCircleWidth solid $waitingCircleTrack;
  border-bottom: $waitingCircleWidth solid $waitingCircleTrack;
  border-left: $waitingCircleWidth solid $waitingCircleSpiner;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: l20-1 0.8s infinite linear alternate, l20-2 1.6s infinite linear;
  animation: l20-1 0.8s infinite linear alternate, l20-2 1.6s infinite linear;

  &, &::after {
    border-radius: 50%;
    width: $waitingCircleSize;
    height: $waitingCircleSize;
  }
  &.big, &.big::after {
    width: $waitingCircleBigSize;
    height: $waitingCircleBigSize;
  }
  &.loading-cart{
    margin: 30px auto;
  }
}

@keyframes l20-1 {
  0%    {clip-path: polygon(50% 50%,0       0,  50%   0%,  50%    0%, 50%    0%, 50%    0%, 50%    0% )}
  12.5% {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100%   0%, 100%   0%, 100%   0% )}
  25%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 100% 100%, 100% 100% )}
  50%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
  62.5% {clip-path: polygon(50% 50%,100%    0, 100%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
  75%   {clip-path: polygon(50% 50%,100% 100%, 100% 100%,  100% 100%, 100% 100%, 50%  100%, 0%   100% )}
  100%  {clip-path: polygon(50% 50%,50%  100%,  50% 100%,   50% 100%,  50% 100%, 50%  100%, 0%   100% )}
}

@keyframes l20-2 { 
  0%    {transform: scaleY(1) rotate(0deg)}
  49.99%{transform: scaleY(1) rotate(135deg)}
  50%   {transform: scaleY(-1) rotate(0deg)}
  100%  {transform: scaleY(-1) rotate(-135deg)}
}

.show-login-popup-js{
	cursor: pointer !important;
}

.swiper-button-pause {
  background: $bgColor;
  fill: $btnSolidBgColor;
  cursor: pointer;
  bottom: 25px;
  right: 10px;
  display: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 4px;
  position: absolute;
  border-radius: 4px;
  z-index: 10;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.20);

  svg {
    width: 24px;
    height: 24px;
  }
}

.clear-after::after {
  display:block;
  clear:both;
  content:'';
}
`